export const landingSetup = () => {
    return {
        title: 'Contractor Set Up',
        subtitle: 'After creating your account you can come back any time to finish setting up your company.'
    }
}
